var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M220 116a12 12 0 0 1 12-12h48a12 12 0 0 1 12 12v137.7l63.5 46.2a12 12 0 0 1 2.6 16.8l-28.2 38.8a12.08 12.08 0 0 1-16.8 2.6L224.9 294a12.08 12.08 0 0 1-4.9-9.7z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm102.1 308.7l-28.2 38.8a12.08 12.08 0 0 1-16.8 2.6L224.9 294a12.08 12.08 0 0 1-4.9-9.7V116a12 12 0 0 1 12-12h48a12 12 0 0 1 12 12v137.7l63.5 46.2a12 12 0 0 1 2.6 16.8z","className":"fa-primary","key":2})]);
}

Clock.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Clock;

Clock.default = Clock;
